import React, { useEffect, useState } from 'react';
import SelectInput from '../../controls/selectInput';
import { apiGet } from '../../services/apiClient';

const IssueStatusInput = (params) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		apiGet('ref/issueStatuses/list')
			.then(data => {
				setOptions(data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; }));
			})
			.catch(err => {
				console.log(err)
			});
	}, []);

	return (
		<SelectInput
			{...params}
			className="issue-status-input"
			value={params.value && params.value.value}
			options={options}
		/>
	);
}

export default IssueStatusInput;


// WEBPACK FOOTER //
// ./App/grids/controls/issueStatusInput.jsx